import { UseMutationResult } from "@tanstack/react-query";
import { Error, Loader } from "bi-lib";
import { PropsWithChildren } from "react";

interface Props<TVariable> extends PropsWithChildren {
    mutationHook: UseMutationResult<unknown, Error, TVariable, unknown>;
}

export default function MutationStatusRouter<TVariable>({ mutationHook, children }: Props<TVariable>) {
    if (mutationHook.isPending) {
        return <Loader />;
    }
    if (mutationHook.isError) {
        return <Error message={mutationHook.error.message} />;
    }
    if (mutationHook.isSuccess) {
        return children;
    }
    return null;
}
